import { createSelector } from 'reselect';

const getTeamMembers = (state) => state.team.teamMembers;

export const getActiveTeamMembers = createSelector([getTeamMembers], (teamMembers) =>
  teamMembers.filter((member) => !member.deleted && member.status !== 'pending'),
);
